(function () {
	'use strict';

    angular.module("imApp").factory("transportAreaPpAddService", ['$ihttp', function ($ihttp) {
		let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1402,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1403,
                    parameters: edit
                });
            }
		};

		return service;
	}]);
})();
